export default function ProductWithRequiredModifiers(product) {
  if (!product.modifiers) return null
  return !!product.modifiers.find(modifier => !modifier.optional)
}
